import {
	faChevronLeft,
	faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { Button, Icon } from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

export function ShipmentsNavigationButtons({
	handleShipmentNavigation,
	prevShipmentNumber,
	nextShipmentNumber,
}: {
	handleShipmentNavigation: (shipmentNumber: number | undefined) => void;
	prevShipmentNumber: number | undefined;
	nextShipmentNumber: number | undefined;
}) {
	const { t } = useTranslation();

	return (
		<>
			<Button
				variant="outline"
				customRadius
				className="flex items-center gap-1  rounded-none rounded-tl-2xl"
				onClick={() => handleShipmentNavigation(prevShipmentNumber)}
				disabled={!prevShipmentNumber}
			>
				<Icon className="size-3" icon={faChevronLeft} />
				{t('pages.shipment-detail.actions.previous', 'Previous')}
			</Button>
			<Button
				variant="outline"
				className="flex items-center gap-1"
				onClick={() => handleShipmentNavigation(nextShipmentNumber)}
				disabled={!nextShipmentNumber}
			>
				{t('pages.shipment-detail.actions.next', 'Next')}
				<Icon className="size-3" icon={faChevronRight} />
			</Button>
		</>
	);
}
